import { render, staticRenderFns } from "./intro-mg.vue?vue&type=template&id=6a5e90a7&scoped=true&"
import script from "./intro-mg.vue?vue&type=script&lang=js&"
export * from "./intro-mg.vue?vue&type=script&lang=js&"
import style0 from "./intro-mg.vue?vue&type=style&index=0&id=6a5e90a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5e90a7",
  null
  
)

export default component.exports